import * as Filters from '~/components/Shared/Filters_DEPRECATED/types';
import { Filter } from '~/evifields/src/types/Filter';
import { api } from '~/redux/api/createApi';

export const getWorkflowsFilterRendererAndSerializer = () => {
  const {
    data = [],
    error,
    isFetching,
  } = api.endpoints.getAvailableWorkflows.useQuery({});

  const AsyncWorkflowsOptionsContainer: Filters.FieldRendererProps = ({
    Component,
    innerProps,
  }) => {
    const options = data.map((workflow: any) => ({
      value: `${workflow.id}`,
      label: workflow.name,
    }));

    return (
      <Component
        asyncProps={{
          asyncOptions: { data: options, error, isFetching },
        }}
        innerProps={innerProps}
      />
    );
  };

  return {
    render: AsyncWorkflowsOptionsContainer,
    serialize: (filter: Filter) => {
      const workflow = data.find((w: any) => `${w.id}` === filter.values[0]);
      return workflow?.name ?? '';
    },
  };
};
